/* eslint-disable no-restricted-imports */
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useSchoolContext } from "./SchoolDataContext";

export function SchoolActivateDialog({
  id,
  isActive,
  show,
  onHide,
  setSuccessMessage,
  setErrorMessage,
}) {
  const context = useSchoolContext();

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
  }, [id]);

  const activateSchool = async () => {
    try {
      if (isActive === true || isActive === "true") {
        // Activate school
        await context.activateSchool(id);
        setSuccessMessage("School Activated Successfully");
      } else {
        // Deactivate school
        await context.deactivateSchool(id);
        setSuccessMessage("School Deactivated Successfully");
      }
      
      onHide();
      
      // Refresh the data
      setTimeout(() => {
        context.setRefetch({ ...context.refetch, schools: true });
      }, 1000);
    } catch (error) {
      console.error("Error activating/deactivating school:", error);
      setErrorMessage(error.message)
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          School {isActive === true || isActive === "true" ? "Activate" : "Deactivate"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>
          Are you sure you want to{" "}
          {isActive === true || isActive === "true" ? "activate" : "deactivate"} this school?
        </span>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={activateSchool}
            className={`btn ${
              isActive === true || isActive === "true" ? "btn-success" : "btn-warning"
            } btn-elevate`}
          >
            {isActive === true || isActive === "true" ? "Activate" : "Deactivate"}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}